import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Paper from 'material-ui/Paper';
import Chip from 'material-ui/Chip';
import Divider from 'material-ui/Divider';
import { List, ListItem } from 'material-ui/List';
import KeyboardArrowRight from 'material-ui-icons/KeyboardArrowRight';
import './Experience.css';
import Avatar from 'material-ui/Avatar';
import asulogo from './img/asu-logo.png';
import roloculelogo from './img/rolocule-logo.png';
import RaisedButton from 'material-ui/RaisedButton';

class Experience extends Component {

    handleTouchTap(param) {
        switch (param) {
            case 'lookinglass': window.open('http://bangladesh-monitor.com:3004/', '_blank');
                break;
            case 'dead among us': window.open('https://play.google.com/store/apps/details?id=com.rolocule.projectz&hl=en', '_blank');
                break;
        }

    }

    render() {
        let leftPosition = this.props.browser.greaterThan.medium || this.props.responsiveDrawer.open ? 200 : 0;

        const style = {
            height: '30px',
            textAlign: 'center',
            backgroundColor: '#4dd0e1',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 0,
            marginLeft: leftPosition,
        };

        const listStyle = {
            marginTop: '5px',
            marginBottom: '5px',
            paddingTop: '2px',
            paddingBottom: '2px',
            marginLeft: '0px',
            paddingLeft: '40px',
            fontFamily: "Raleway, sans-serif",
            lineHeight: 1.3
        }

        const chipsStyles = {
            chip: {
                margin: 4,
                backgroundColor: '#4dd0e1',
                fontFamily: "Raleway, sans-serif"
            },
            wrapper: {
                display: 'flex',
                flexWrap: 'wrap',
                marginBottom: '10px'
            },
        };

        const chipStyleWebsite = {
            chip: {
                margin: 4,
                backgroundColor: '#4dd0e1',
                fontFamily: "Raleway, sans-serif",
                display: 'inline-block'
            },
            wrapper: {
                display: 'flex',
                flexWrap: 'wrap',
                marginBottom: '10px'
            },
        };

        const iconStyle = {
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '-2px',
            marginBottom: '2px',
            paddingTop: '0px',
            paddingBottom: '0px',
            paddingLeft: '0px',
            marginLeft: '0px',
            display: 'flex',
            height: 25,
            width: 25
        }

        const logoStyle = {
            float: 'right',
            marginTop: 20,
            backgroundColor: '#efebe9',
            width: 100
        }

        const buttonStyle = {
            margin: 12,
            display: 'inline-block'
        };

        return (
            <Grid className="Experience" style={{ margin: 0, width: '100%', backgroundColor: '#efebe9' }}>
                <Row style={{ margin: 0 }}>
                    <Col xs style={{ padding: 0 }}>
                        <Paper style={style} zDepth={1}
                            />
                    </Col>
                </Row>
                <Row style={{ margin: 0 }}>
                    <Col xs>
                        <Row center="xs">
                            <Col xs={10}>

                                <img src={asulogo} style={logoStyle} />
                                <div style={{ textAlign: 'left', marginLeft: leftPosition }}>
                                    <h2 style={{ display: 'inline-block' }}> Research Assistant |</h2>
                                    <h4 style={{ display: 'inline-block' }}> &nbsp;Full Stack Engineer</h4>
                                    <p> Oct 2016 - Current</p>
                                    <List>
                                        <h3 style={{ display: 'inline-block', fontFamily: "Raleway, sans-serif", marginLeft: 10, marginRight: 20 }}>UN Project - Lookinglass</h3>
                                        <a href="http://bangladesh-monitor.com:3004/" target="_blank">
                                            View website
                                        </a>
                                        <p  style={{ display: 'inline-block', fontFamily: "Raleway, sans-serif", marginLeft: 5, marginRight: 20, fontSize: 12 }}>(Username: admin, Password: Welcome@123)</p>
                                        <ListItem style={listStyle} disabled={true} primaryText="Social media project for big data analysis of political affiliations on social media, public sentiments & influential users" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Scraped dark web, social media data anonymously and maintained ETL pipeline for its sentimental analysis" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Migrated Apache Solr to Elasticsearch – Designed distributed multi-node cluster to improve reliability, availability and performance; Indexed over half billion data records in Elasticsearch for fast retrieval" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Integrated React, Redux into dashboard websites to ensure high quality and reusability of code" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                    </List>
                                    <div style={chipsStyles.wrapper}>
                                        <Chip style={chipsStyles.chip}>
                                            React
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Redux
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Python
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Elasticsearch
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Postgres
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Node.js
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Express.js
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Apache Solr
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            D3.js
                                            </Chip>
                                    </div>
                                    <List>
                                        <h3 style={{ display: 'inline-block', fontFamily: "Raleway, sans-serif", marginLeft: 10, marginRight: 20 }}>Lockheed Martin Project</h3>
                                        <ListItem style={listStyle} disabled={true} primaryText="An NLP project for real-time discovery of frames, frameshifts, detection of emergence of new frames in contexts where intent of adversary is unknown" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Wrote batch script to automate project pipeline" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Incorporated hashing to reduce time complexity of string matching" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Created visualization website to explore the content of large set of news articles to leverage quick reading" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                    </List>
                                    <div style={chipsStyles.wrapper}>
                                        <Chip style={chipsStyles.chip}>
                                            Python
                                        </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Elasticsearch
                                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Stanford Corenlp
                                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Neuralcoref
                                        </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Javascript
                                        </Chip>
                                    </div>
                                </div>

                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Divider style={{ backgroundColor: '#75ccb9' }} />
                <Row style={{ margin: 0 }}>
                    <Col xs>
                        <Row center="xs">
                            <Col xs={10}>
                                <img src={roloculelogo} style={logoStyle} />
                                <div style={{ textAlign: 'left', marginLeft: leftPosition }}>
                                    <h2 style={{ display: 'inline-block' }}> Rolocule Games |</h2>
                                    <h4 style={{ display: 'inline-block' }}> &nbsp;Team Lead </h4>
                                    <p>Oct 2015 - June 2016</p>
                                    <List>
                                        <h3 style={{ display: 'inline-block', fontFamily: "Raleway, sans-serif", marginLeft: 10, marginRight: 20 }}>Mahayudh</h3>
                                        <ListItem style={listStyle} disabled={true} primaryText="Led development of “Mahayudh”; a mobile fighting game from conception to prototype stage" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Worked closely with project manager, developers, artists to produce accurate delivery estimates" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Integrated IoC/Dependency Injection MVC Framework for decoupled, modular code, and rapid development" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Designed game architecture" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Implemented initial prototype, foundational modules, gameplay" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                    </List>
                                    <div style={chipsStyles.wrapper}>
                                        <Chip style={chipsStyles.chip}>
                                            Unity
                                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            C#
                                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Strange-IoC
                                                </Chip>
                                    </div>
                                </div>

                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Divider style={{ backgroundColor: '#75ccb9' }} />
                <Row style={{ margin: 0 }}>
                    <Col xs>
                        <Row center="xs">
                            <Col xs={10}>
                                <img src={roloculelogo} style={logoStyle} />
                                <div style={{ textAlign: 'left', marginLeft: leftPosition }}>
                                    <h2 style={{ display: 'inline-block' }}> Rolocule Games |</h2>
                                    <h4 style={{ display: 'inline-block' }}> &nbsp;Software Engineer </h4>
                                    <p>Jul 2013 - Sep 2015</p>
                                    <List>
                                        <h3 style={{ display: 'inline-block', fontFamily: "Raleway, sans-serif", marginLeft: 10, marginRight: 20 }}>Dead Among Us</h3>
                                        
                                            <a href="https://play.google.com/store/apps/details?id=com.rolocule.projectz&hl=en" target="_blank">
                                                View website
                                            </a>
                                        
                                        <ListItem style={listStyle} disabled={true} primaryText="A mobile 3D zombie-apocalypse archery FPS game for iOS and Android" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Built and maintained a complete game User Interface" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Profiled the CPU, GPU, and memory usage and improved the game performance by 25% " leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Game of the year award at Nasscom Game Development Conference'15" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Received outstanding performer for two consecutive years at Rolocule Games" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                    </List>
                                    <div style={chipsStyles.wrapper}>
                                        <Chip style={chipsStyles.chip}>
                                            Unity
                                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            C#
                                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            NGUI
                                                </Chip>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Grid>

        );
    }
}

const mapStateToProps = (state) => {
    const { browser, responsiveDrawer } = state;
    return {
        browser,
        responsiveDrawer
    };
};

export default connect(mapStateToProps, null)(Experience);


// WEBPACK FOOTER //
// ./src/Experience.js